import { ThunkType } from "../../../../../core/store/reducers";
import { getBusinessActivitiesReport } from "../api/getBusinessActivitiesReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../businessActivitiesDataSlice";

export const downloadBusinessActivitiesReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.exchbusiness.businessActivities;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const ordersReport = await dispatch(
    getBusinessActivitiesReport(user, filter)
  );
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "BusinessActivities.pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
